__turbopack_context__.v({
  "buttonWrapper": "price-history-button-module-scss-module__63cImW__buttonWrapper",
});
